// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"664":"component---src-pages-gatsby-example-js","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"664":"12fc6394350d0fd4af8f","678":"ed01a662cf388e85f1c1","883":"5728ecaabf752d2c58d7"}[chunkId] + ".js";
};